/* External */
import { useCallback } from 'react';

export default function useHandleFocusRestoredCarousel(setPositionCarousel) {
  return useCallback(({ index }) => {
    setPositionCarousel(index);
  }, [setPositionCarousel]);
}
